export enum LinkType {
  sharepoinLink = 'app',
  personalLink = 'mylink',
  sharepointSite = 'sharepoint'
}
